import db from './Database';

class AIHandler {
    constructor() {
        this.currentModel = null;
    }

    async initialize() {
        try {
            const model = await db.aiModels.toArray();
            if (model && model.length > 0) {
                this.currentModel = model[0];
            }
            return this.currentModel;
        } catch (error) {
            console.error('Erreur lors de l\'initialisation du modèle AI:', error);
            throw error;
        }
    }

    async query(prompt, systemPrompt = '') {
        if (!this.currentModel) {
            await this.initialize();
        }

        if (!this.currentModel) {
            throw new Error('Aucun modèle AI configuré');
        }

        try {
            const response = await fetch(this.currentModel.baseURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.currentModel.apiKey}`
                },
                body: JSON.stringify({
                    model: this.currentModel.model,
                    messages: [
                        ...(systemPrompt ? [{role: "system", content: systemPrompt}] : []),
                        {role: "user", content: prompt}
                    ],
                    max_tokens: this.currentModel.maxtokens,
                    temperature: 0.7,
                })
            });

            if (!response.ok) {
                throw new Error(`Erreur API: ${response.status}`);
            }

            const data = await response.json();
            return data.choices[0].message.content;
        } catch (error) {
            console.error('Erreur lors de la requête AI:', error);
            throw error;
        }
    }

    async updateModel(modelConfig) {
        try {
            await db.aiModels.clear();
            await db.aiModels.add(modelConfig);
            this.currentModel = modelConfig;
        } catch (error) {
            console.error('Erreur lors de la mise à jour du modèle:', error);
            throw error;
        }
    }
}

const aiHandler = new AIHandler();
export default aiHandler;
